import { createSlice, PayloadAction} from "@reduxjs/toolkit";
import {getProductsFiltersRep} from "../../Repository/ProductFilterRepository";
import {RequestError} from "../../Entity/RequestError";
import {AppThunk} from "../../../app/store";
import {Filter} from "../../Entity/Filter";

interface ProductFilterState {
  isRequesting: boolean,
  isRequestSuccess: boolean,
  isRequestFailed: boolean,
  error: RequestError | null,
  filters: Filter[]|null,
}

const ProductFiltersInitialState: ProductFilterState = {
  isRequesting: false,
  isRequestSuccess: false,
  isRequestFailed: false,
  filters: null,
  error: null,
}

function startRequest(state: ProductFilterState) {
  state.isRequesting = true;
  state.isRequestFailed = false;
  state.filters = null;
}

function registerFailed(state: ProductFilterState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}
function registerSuccess(state: ProductFilterState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
  state.filters = action.payload["hydra:member"] as Filter[];
  state.error = null;
  document.dispatchEvent(new Event("onDatatablesDataReceived"));
}

const productFilterSlice = createSlice({
    name: 'filters',
    initialState: ProductFiltersInitialState,
    reducers: {
      ProductFiltersStartRequest: startRequest,
      ProductFiltersSuccess: registerSuccess,
      ProductFiltersFailed: registerFailed,
    }
  }
)

export const {
  ProductFiltersStartRequest,
  ProductFiltersSuccess,
  ProductFiltersFailed,
} = productFilterSlice.actions;

export default productFilterSlice.reducer;

export const getProductsFilters = (locale:string): AppThunk => async dispatch => {
  try {
    dispatch(ProductFiltersStartRequest());
    const newsApiResponse = await getProductsFiltersRep(locale);
    dispatch(ProductFiltersSuccess(newsApiResponse));
  } catch (err) {
    dispatch(ProductFiltersFailed(err));
  }
}
